
/* ==========================================================================
   LINKS — static filenames to theme routes

   The front end links to `accessories.html`, `machine.html?m=smith` and so
   on, because that is what the static build is. On Shopify those are pages
   and products with entirely different URLs, and every one of them 404s.

   The layout publishes the real routes as window.IFZ_URLS; this maps the
   static names onto them. With IFZ_URLS unset — the static build — every
   link is returned untouched, so one codebase serves both.

   Rewriting happens in two places: every anchor on the page at load, and
   again on click, because a lot of these links are built by JS long after
   load (the deck, the menu, the package rack).
   ========================================================================== */
window.IFZU = function (href) {
  var U = window.IFZ_URLS;
  if (!href || !U) return href;

  var m = String(href).match(/^([a-z-]+\.html)(\?[^#]*)?(#.*)?$/i);
  if (!m) return href;

  var file = m[1].toLowerCase(), query = m[2] || '', hash = m[3] || '';

  if (file === 'machine.html') {
    var mk = (query.match(/[?&]m=([a-z0-9-]+)/i) || [])[1];
    var handle = U.products && U.products[mk];
    return handle ? (U.productBase + handle + hash) : (U.home + hash);
  }
  if (file === 'fit.html')         return U.fit + query + hash;
  if (file === 'tools.html')       return U.tools + hash;
  if (file === 'accessories.html') return U.accessories + hash;
  if (file === 'bundle.html')      return U.package + query + hash;
  if (file === 'cart-revamp.html') return U.cart + hash;
  if (file === 'index.html')       return U.home + hash;
  return href;
};

(function () {
  function sweep(root) {
    if (!window.IFZ_URLS) return;
    var as = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < as.length; i++) {
      var h = as[i].getAttribute('href');
      var n = window.IFZU(h);
      if (n !== h) as[i].setAttribute('href', n);
    }
  }
  window.IFZUSweep = sweep;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweep(); });
  } else { sweep(); }

  /* Anything built after load — the menu, the deck, the package rack. */
  document.addEventListener('click', function (e) {
    if (!window.IFZ_URLS || !e.target.closest) return;
    var a = e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href');
    var n = window.IFZU(h);
    if (n !== h) a.setAttribute('href', n);
  }, true);
})();

/* ==========================================================================
   ASSET PATHS — static site and Shopify theme from one codebase

   On the static site an image lives at `assets/spin-cable-1.jpg`. In a
   Shopify theme the same file is served from the CDN under a hashed URL,
   and there is no `assets/` folder to be relative to.

   So every path goes through here. The layout sets IFZ_ASSET_BASE:

     window.IFZ_ASSET_BASE = "{{ 'ifz-icon.svg' | asset_url | split: 'ifz-icon.svg' | first }}";

   With it unset — which is the static site — this returns the path
   untouched, so the two behave identically and there is no second codebase
   to keep in step.
   ========================================================================== */
window.IFZA = function (path) {
  if (!path) return path;

  /* The 3D models are 12-15 MB each and 41 MB together, which pushes a
     theme past Shopify's 50 MB zip limit on its own. So they live in
     Shopify Files instead of the theme, and IFZ_MODEL_BASE points at them.
     Everything else comes from the theme's own assets. */
  if (window.IFZ_MODEL_BASE && /\.glb(\?|$)/i.test(path)) {
    return String(path).replace(/^assets\//, window.IFZ_MODEL_BASE);
  }

  var base = window.IFZ_ASSET_BASE;
  if (!base) return path;
  return String(path).replace(/^assets\//, base);
};

/* ==========================================================================
   IRON FIT — shared cart store
   localStorage-backed so the cart survives page moves and reloads.
   Items: { type: 'machine'|'package'|'accessory'|'tool', name, price,
            img, qty, extras: [{ name, price }], includes: [strings] }
   Any element with [data-cart-count] becomes a live badge.

   `img` and `qty` are newer than the rest. Both are optional everywhere —
   a cart written before they existed still reads, and a caller that omits
   them still works (qty falls back to 1, the thumbnail slot to a
   placeholder). That matters: this is localStorage, so a returning
   customer's cart predates today's code.
   ========================================================================== */
window.IFZCart = (function () {
  'use strict';

  var KEY = 'ifz-cart-v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    badge();
  }

  function qtyOf(it) { return Math.max(1, parseInt(it && it.qty, 10) || 1); }

  /* Two lines are the same line only if the thing AND its extras match —
     a Smith machine with 40 kg of plates is not the same order line as a
     bare one, and merging them would silently change what was bought. */
  function sig(it) {
    return [it.type, it.name, it.price].concat(
      (it.extras || []).map(function (e) { return e.name + ':' + e.price; }).sort()
    ).join('|');
  }

  function add(item) {
    var it = read();
    var s = sig(item);
    var merged = false;
    for (var i = 0; i < it.length; i++) {
      if (sig(it[i]) === s) { it[i].qty = qtyOf(it[i]) + qtyOf(item); merged = true; break; }
    }
    if (!merged) { item.qty = qtyOf(item); it.push(item); }
    write(it);
    /* the pixel is only present on pages that load ifz-pixel.js */
    if (window.IFZPixel) window.IFZPixel.addToCart(item);
  }

  function removeAt(i) { var it = read(); it.splice(i, 1); write(it); }

  /* Down to zero removes the line — the same thing the Remove button does,
     reached the way people expect from every other cart. */
  function setQty(i, q) {
    var it = read();
    if (!it[i]) return;
    q = Math.max(0, Math.min(99, parseInt(q, 10) || 0));
    if (q === 0) it.splice(i, 1); else it[i].qty = q;
    write(it);
  }

  function clear() { write([]); }

  function count() {
    return read().reduce(function (s, it) { return s + qtyOf(it); }, 0);
  }

  function itemTotal(it) {
    var t = it.price;
    (it.extras || []).forEach(function (e) { t += e.price; });
    return t * qtyOf(it);
  }

  function total() {
    return read().reduce(function (s, it) { return s + itemTotal(it); }, 0);
  }

  function money(n) { return '$' + n.toLocaleString('en-US'); }

  function badge() {
    var n = count();
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n === 0) { els[i].setAttribute('hidden', ''); }
      else { els[i].removeAttribute('hidden'); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', badge);
  } else {
    badge();
  }

  return { read: read, write: write, add: add, removeAt: removeAt, setQty: setQty,
           qtyOf: qtyOf, clear: clear, count: count, total: total,
           itemTotal: itemTotal, money: money, badge: badge };
})();

/* ==========================================================================
   Shared picture builder — WebP with a JPEG underneath.

   Every photo on the site now ships in both formats; WebP is about half the
   weight at the same quality. A <picture> lets the browser choose, so a
   phone too old for WebP (an iPhone on iOS 13, say) still gets the JPEG
   rather than an empty box.

   IFZPic('assets/x.jpg', alt) → <picture><source …webp><img src=…jpg></picture>

   A browser that takes the <source> does NOT fall back to the <img> on its
   own if that WebP is missing — it just shows nothing. So the one error the
   caller can actually make (a file with no .webp beside it) is caught here:
   drop the source and let the original load.
   ========================================================================== */
window.IFZPic = function (src, alt, cls) {
  src = window.IFZA(src);
  var pic = document.createElement('picture');

  var source = document.createElement('source');
  source.type = 'image/webp';
  source.srcset = src.replace(/\.(jpe?g|png)$/i, '.webp');
  pic.appendChild(source);

  var img = document.createElement('img');
  img.alt = alt || '';
  if (cls) img.className = cls;

  img.addEventListener('error', function once() {
    img.removeEventListener('error', once);
    if (!source.parentNode) return;
    pic.removeChild(source);
    img.src = src;                 /* re-run the pick, now JPEG-only */
  });

  img.src = src;
  pic.appendChild(img);

  return pic;
};

/* ==========================================================================
   Shared extra-plates picker — the old builder's UI: pairs of 5 / 10 / 20 kg
   plates, capped at 80 kg extra. A pair adds 2 × its size.
   IFZPlates(container, onChange) → { kg(), rows() }
   Pricing is the caller's job (package rate vs standalone rate differ).
   ========================================================================== */
window.IFZPlates = function (container, onChange) {
  'use strict';

  var MAX_KG = 80;
  var SIZES = [5, 10, 20];
  var pairs = { 5: 0, 10: 0, 20: 0 };

  function kg() {
    return 2 * (5 * pairs[5] + 10 * pairs[10] + 20 * pairs[20]);
  }

  var reads = {};

  function refresh() {
    SIZES.forEach(function (s) {
      reads[s].count.textContent = pairs[s];
      reads[s].added.textContent = '(+' + (2 * s * pairs[s]) + ' KG)';
    });
    onChange(kg());
  }

  SIZES.forEach(function (s) {
    var row = document.createElement('div');
    row.className = 'plr';

    var badge = document.createElement('span');
    badge.className = 'plr__badge';
    badge.innerHTML = s + '<small>KG</small>';

    var name = document.createElement('span');
    name.className = 'plr__name';
    name.textContent = s + ' KG Plates';

    var qty = document.createElement('div');
    qty.className = 'plr__qty';
    var minus = document.createElement('button');
    minus.type = 'button'; minus.textContent = '−';
    minus.setAttribute('aria-label', 'Fewer pairs of ' + s + ' kg plates');
    var n = document.createElement('span'); n.textContent = '0';
    var plus = document.createElement('button');
    plus.type = 'button'; plus.textContent = '+';
    plus.setAttribute('aria-label', 'More pairs of ' + s + ' kg plates');
    qty.appendChild(minus); qty.appendChild(n); qty.appendChild(plus);

    var side = document.createElement('span');
    side.className = 'plr__side';
    var added = document.createElement('b');
    added.textContent = '(+0 KG)';
    side.appendChild(document.createTextNode('Pairs '));
    side.appendChild(added);

    reads[s] = { count: n, added: added };

    minus.addEventListener('click', function (e) {
      e.stopPropagation();
      if (pairs[s] > 0) { pairs[s]--; refresh(); }
    });
    plus.addEventListener('click', function (e) {
      e.stopPropagation();
      if (kg() + 2 * s <= MAX_KG) { pairs[s]++; refresh(); }
    });

    row.appendChild(badge); row.appendChild(name); row.appendChild(qty); row.appendChild(side);
    container.appendChild(row);
  });

  return { kg: kg };
};
